import { render } from "./AdditionalSection.vue?vue&type=template&id=92936a1e"
import script from "./AdditionalSection.vue?vue&type=script&lang=js"
export * from "./AdditionalSection.vue?vue&type=script&lang=js"

import "./AdditionalSection.vue?vue&type=style&index=0&id=92936a1e&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__